import {getSiteStatus} from '@/api/sites';
import {useEffect, useState} from 'react';
import {useQuery} from '@tanstack/react-query';
import type {SiteStatusSimple} from '@/types/api';

function isTerminalStatus(data: SiteStatusSimple | undefined): boolean {
    if (!data) {
        return false;
    }
    return data.status === 'active' || data.status === 'failed' || data.provisioning_status === 'failed';
}

export function useSiteStatus(siteId: string) {
    const [isVisible, setIsVisible] = useState(() => document.visibilityState === 'visible');

    useEffect(() => {
        const updateVisibility = () => setIsVisible(document.visibilityState === 'visible');
        document.addEventListener('visibilitychange', updateVisibility);
        return () => document.removeEventListener('visibilitychange', updateVisibility);
    }, []);

    return useQuery({
        queryKey: ['site-status', siteId],
        queryFn: () => getSiteStatus(siteId),
        enabled: !!siteId,
        refetchInterval: (data) => {
            if (isTerminalStatus(data)) {
                return false;
            }
            return isVisible ? 1000 : 5000;
        },
        refetchOnWindowFocus: true,
        retry: 2
    });
}
